module.exports = __webpack_public_path__ + "img/d850668.png";